import styled from 'styled-components'

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 7px;
  background-color: transparent;
  overflow: hidden;
`

export const ProgressBarFill = styled.div<{ $progress: number }>`
  height: 100%;
  width: ${({ $progress }) => Math.min(Math.max($progress, 0), 100)}%;
  background-color: #0080ae;
  border-radius: 0 3px 3px 0;
  transition: width 0.3s ease; // Moves it smoothly as otherwise it would not be recognised at all by a user
`

/**
 * Progress bar component introduces it as the old one was no more compatible after the next.js 13-> 14 upgrade with newer
 * styled components.
 *
 * @param progress the progress value between 0 and 100
 * @constructor
 */
const ProgressBar = ({ progress }) => (
  <ProgressBarContainer>
    <ProgressBarFill $progress={progress} />
  </ProgressBarContainer>
)

export default ProgressBar
